// extracted by mini-css-extract-plugin
export var block_color = "ProductCard-module--block_color--98d2d";
export var container_color = "ProductCard-module--container_color--bc286";
export var container_img = "ProductCard-module--container_img--7d3e4";
export var img = "ProductCard-module--img--3c7b5";
export var link = "ProductCard-module--link--04e78";
export var productCard__button = "ProductCard-module--productCard__button--4e5d4";
export var productCard__colors = "ProductCard-module--productCard__colors--b941f";
export var productCard__container = "ProductCard-module--productCard__container--ba1c9";
export var productCard__link = "ProductCard-module--productCard__link--9d896";
export var productCard__model = "ProductCard-module--productCard__model--ba0d3";
export var productCard__name = "ProductCard-module--productCard__name--fa0e3";